import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Sun, Moon, ArrowUpRight } from "lucide-react";
import { Logo } from "@/components/Logo";
import { CALCULATORS } from "@/data/calculators";

export function Nav() {
  const [dark, setDark] = useState(() => document.documentElement.classList.contains("dark"));

  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    try {
      localStorage.setItem("cm-theme", dark ? "dark" : "light");
    } catch (e) {}
  }, [dark]);

  return (
    <header className="sticky top-0 z-50 border-b border-border/80 bg-background/85 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-5 sm:px-8">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5">
          <Logo className="h-8 w-8" />
          <span className="font-serif text-xl font-semibold tracking-tight">Curiosímetro</span>
        </Link>

        <nav className="hidden items-center gap-6 lg:flex">
          <NavLink
            to="/#calculadoras"
            data-testid="nav-link-calculadoras"
            className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground transition-colors hover:text-primary"
          >
            Calculadoras
          </NavLink>
          <NavLink
            to="/#sabias-que"
            data-testid="nav-link-sabias-que"
            className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground transition-colors hover:text-primary"
          >
            Sabías que
          </NavLink>
          {CALCULATORS.slice(0, 3).map((c) => (
            <Link
              key={c.slug}
              to={`/${c.slug}`}
              data-testid={`nav-calculator-${c.slug}`}
              className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground transition-colors hover:text-primary"
            >
              {c.short}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="theme-toggle-button"
            onClick={() => setDark((d) => !d)}
            aria-label={dark ? "Activar modo claro" : "Activar modo oscuro"}
            className="flex h-9 w-9 items-center justify-center rounded-full border border-border text-muted-foreground transition-all hover:border-primary hover:text-primary"
          >
            {dark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
          </button>
          <Link
            to="/#calculadoras"
            data-testid="nav-cta"
            className="group hidden items-center gap-1.5 rounded-full bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-all hover:shadow-offset-accent sm:flex"
          >
            Medirme ahora
            <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </div>
      </div>
    </header>
  );
}
